import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useCreate from "../../useCreate";
import toast from "react-hot-toast";

const useCreateAttribute = ({ reset }) => {
  const { attributeId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setDataToServer } = useCreate({
    url: "product/attribute/create",
    refreshUrl: "product/attribute/list",
    onSuccess: () => {
      if (searchParams.get("mode") === "edit") {
        navigate(`/catalog/variants/attributes`);
      } else {
        reset?.();
      }
      toast.success("Attribute Added Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const handleSubmit = (data) => {
    let finalFormData;
    if (attributeId) {
      finalFormData = {
        ...data,
        attribute_id: attributeId,
      };
    } else {
      finalFormData = data;
    }
    setDataToServer.mutate(finalFormData);
  };

  return { handleSubmit };
};

export default useCreateAttribute;
